var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"msgTable",attrs:{"paging":"","height":"500px","pageUnit":10,"totalSize":_vm.popup.groups.totalSize,"columns":_vm.columns,"currentPage":_vm.popup.groups.currentPage,"rows":_vm.dicMsgManagements,"span-method":_vm.objectSpanMethod,"stripe":false,"selection":false},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }